import { AnyAction } from 'redux';
import { RESET_STATE, GET_ALL_AGENTS, GET_AGENT_TYPES, GET_AGENT_TYPES_LOADING, GET_ALL_AGENTS_LOADING, SET_AGENT_COUNT, GET_AGENT_DETAIL } from '@app/store/constants';

const initialState = {
    agents: [],
    count: 0,
    agentsLoading: false,
    agentTypes: [],
    agentTypesLoading: false,
    agentDetails: {}
};

export function agents(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;

        case GET_ALL_AGENTS:
            return {
                ...state,
                agents: payload
            };

        case GET_ALL_AGENTS_LOADING:
            return {
                ...state,
                agentsLoading: payload
            };

        case GET_AGENT_TYPES:
            return {
                ...state,
                agentTypes: payload
            };

        case GET_AGENT_TYPES_LOADING:
            return {
                ...state,
                agentTypesLoading: payload
            };

        case SET_AGENT_COUNT:
            return {
                ...state,
                count: payload
            };

        case GET_AGENT_DETAIL:
            return {
                ...state,
                agentDetails: payload
            };

        default:
            return state;
    }
}
